<template>
  <div class="home home-container">
    <!-- 网站公告 -->
    <homeNotice/>
    <!-- 首页轮播 -->
    <div class="home-banner" v-if="homeBannerList.length > 0"  :style="{height: divHeight}">
      <div class="swiper-container home-banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in homeBannerList">
            <a :href="item.href" @click='clickFun'>
              <img :src="item.img">
            </a>
          </div>
        </div>
        <div class="swiper-pagination" v-if="homeBannerList.length > 1"></div>
      </div>
    </div>
    <div class="home-wrap">
      <!-- 本季推荐 横向滚动 -->
      <div class="home-item" v-if="seasonBannerList.length > 0">
        <div class="home-item-title">
          <div class="cj-wrap">
            <img src="/static/images/icon_cj.png" class="icon-cj">
          </div>
          <div class="home-item-name">
            <p>
              <span class="bold">{{seasons.title.slice(0,2)}}</span><span>{{seasons.title.slice(2,4)}}</span>
            </p>
            <p class="title-en">{{seasons.desc}}</p>
          </div>
          <div class="name-en"> </div>
        </div>
        <div class="swiper-wrap clearfix">
          <a :href="item.href" v-for="item in seasonBannerList">
            <img :src="item.img">
          </a>
        </div>
      </div>

      <!-- 本季推荐、新品推荐、经典推荐 -->
      <template v-if="goodsList.length > 0" v-for="(pdata, index) in goodsList">
        <homeItem :pindex="index" :pdata="pdata" :isChangeList="isChangeList" :clear="clear" class="no-border" v-if="flag&&pdata"
                  v-show="pdata.source.goods.length"></homeItem>
      </template>
    </div>
    <!-- 活动专区 -->
    <div class="partner" v-if="partners.length > 0" v-for="item in partners">
      <template v-if="item.source.adsense.length > 0">
        <p class="partner-title">{{item.title}} {{item.info}}</p>
        <div class="partner-wrap">
          <div v-for="adsense in item.source.adsense" class="partnerImg">
            <a :href="adsense.href">
              <img :src="adsense.img">
            </a>
          </div>
        </div>
      </template>
    </div>
    <!-- 底部 -->
    <homeFooter/>
    <!-- 导航 -->
    <homeNav :clear="clear" @getHeight="getHeight"/>
    <!-- 下雪效果 -->
    <homeSnowing v-if="scene.snow"/>
    <!-- 返回旧版 -->
    <returnOldVersion/>
    <!-- 新客弹窗 -->
   <!-- <newUserPopup/> -->
    <!-- 浮窗 -->
    <!-- <homeFloat/> -->
  </div>
</template>
<script>
  import homeNotice from '../components/home/home-notice'
  import homeItem from '../components/home-item'
  import homeNav from '../components/footer'
  import homeFooter from '../components/home/home-footer'
  import newUserPopup from '../components/home/new-user-popup'
  import returnOldVersion from '../components/home/return-old-version'
  import homeSnowing from '../components/home/home-snowing'
  import Swiper from '../../static/js/swiper.min.js'

  import homeFloat from '../components/home/home-float'

  export default {
    name: 'home',
    components: {
      homeNotice,
      homeItem,
      homeFooter,
      homeNav,
      newUserPopup,
      returnOldVersion,
      homeSnowing,
      homeFloat
    },
    data () {
      return {
        cityId: window.store.get('city_id') || 110,
        seasons: {
          title: '',
          desc: '',
          alias: ''
        },
        partners: [],
        goodsList: [],
        homeBannerList: [],
        seasonBannerList: [],
        flag: false,
        res: {},
        scene: {
          snow: false,
          show: false
        },
        height:0,
        menuHeight:0
      }
    },
    activated () {
      if (window.store.get('user_auth')) {
        this.scene.show = true
      } else {
        this.scene.show = false
      }
    },
    computed: {

    },
    mounted () {
      this.init();
       //let navheight = window.store.get('navheight')-0
       //let divHeight = document.body.clientHeight-this.menuHeight - navheight+"px";
       //this.divHeight = divHeight;

    },
    props: ['isChangeList', 'clear'],
    watch: {
      isChangeList: {
        handler (newValue, oldValue) {
          if (this.isChangeList.num == 1) {
            return false
          }
        },
        deep: true
      }
    },
    methods: {
      clickFun() {
        _hmt.push(['_trackCustomEvent', 'click', {}])
      },
      getHeight(data){
        this.menuHeight = data;
      },
      init () {
        let self = this
        if (self.cityId) {
          let url = ''
          if (window.location.href.indexOf('https://test.h5.mcake.com') > -1) {
            url = 'https://test.static.mcake.com/data/pages/wap/home/' + self.cityId + '.json?t=' + new Date().getTime()
          } else {
            url = this.cdn + '/data/pages/wap/home/' + self.cityId + '.json?t=' + new Date().getTime()
          }
          loadScript(url, function () {
            self.res = homeData
            for (let i = 0; i < self.res.list.length; i++) {
              if (self.res.list[i].type == 1 && self.res.list[i].display == 3) { // 轮播模式（首页轮播）
                self.homeBannerList = self.res.list[i].source.adsense
              }
              if (self.res.list[i].type == 1 && self.res.list[i].display == 4) { // 横屏模式（本季推荐）
                self.seasonBannerList = self.res.list[i].source.adsense
                self.seasons.title = self.res.list[i].title
                self.seasons.desc = self.res.list[i].info
                self.seasons.alias = self.res.list[i].alias
              }
              if (self.res.list[i].type == 2 && self.res.list[i].display == 2) { // 网格模式（新品推荐、人气推荐、经典推荐）
                self.goodsList.push(self.res.list[i])
              }
              if (self.res.list[i].type == 1 && self.res.list[i].display == 1 && self.res.list[i].source.adsense.length > 0) { // 列表模式（银行专区、企业专区）
                self.partners.push(self.res.list[i])
              }
            }
            self.flag = true
            if (self.homeBannerList.length > 1) {
              self.$nextTick(function () {
                let proSwiper = new Swiper('.home-banner-swiper', {
                  loop: true,
                  slidesPerView: 1,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                  },
                  autoplay: {
                    disableOnInteraction: false
                  }
                })
              })
            }
          })
        }
        self.loadScene()
      },
      loadScene () {
        let self = this
        self.$http.get(self.host + '/api/67f384075e4298d9', {
          params: {
            cityId: self.cityId
          }
        }).then(function (res) {
          if (res.code == 1 && res.data.length > 0) {
            res.data.forEach(item => {
              if (item.scene == 'snow') {
                self.scene.snow = true
              }
            })
          }
        }, function (error) {
          console.log(error)
        })
      }
    }
  }
</script>
<style scoped>
  @import '../../static/css/swiper.min.css';

  .home {
    background-color: #fff;
    position: relative;
  }
  .home-banner{height: 10.053rem;}
  .home-item {
    text-align: left;
    border-top: 1px solid #dfdfdf;
  }

  .no-border .home-item {
    border: none;
  }

  .icon-cj {
    width: 1.53rem;
  }

  .name-en {
    font-size: .266666666rem;
    color: #b2b2b2;
    flex: 1;
    text-align: right;
  }

  .name-en span {
    display: inline-block;
    margin-top: .2rem;
  }

  .cj-wrap {
    flex: 1;
  }

  .home-item-name {
    font-size: .4rem;
    color: #000;
    flex: 2
  }

  .home-item-name span:first-child {
    font-weight: bold;
  }

  .title-en {
    font-size: .18666666rem;
    color: #7f7f7f;
  }

  .home-item-title {
    padding: 1.2rem .6rem;
    display: flex;
  }

  .swiper-wrap {
    padding:0 0 0 0.08rem;
    height: 3.86666666rem;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    display: flex;
  }

  .home-item .swiper-wrap a, .home-item .swiper-wrap a img {
    height: 100%;
    width: auto;
    display: block;
  }

  .partner {
    padding: .2rem;
  }

  .partner-title {
    color: #151515;
    text-align: center;
    font-size: .3733333rem;
    padding: 1.3rem 0 .9rem;
    font-weight: bold;
  }

  .partner-wrap .partnerImg {
    min-height: 3.32rem;
    background-image: url(/static/images/parnter_bc.jpg);
    background-size: cover;
    margin-top: .2rem;
  }

  .partner-wrap .partnerImg:first-child {
    margin-top: 0;
  }

  .swiper-slide img {
    width: 100%;
    height: auto;
  }

  .chirs-line {
    width: 100%;
    height: 1.5rem;
    position: fixed;
    bottom: 1rem;
    background: url(/static/images/chirs-line-0.png) center center no-repeat;
    z-index: 5;
  }


  #snow {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    pointer-events: none;
    z-index: 10;
  }

  .home-item-name{position: relative;}
  .dis{position: absolute; top: 0; left: 2.02rem; width: 0.7rem;}

</style>



// WEBPACK FOOTER //
// src/pages/home.vue